import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
  ViewChild,
} from '@angular/core';
import { NgOtpInputComponent } from 'ng-otp-input';
import { CommonService } from '../../service/common.service';

/** Digits in every e-mail code the API issues. */
export const OTP_LENGTH: number = 6;

/**
 * Six digit e-mail code with its own resend countdown.
 *
 * It never calls an API: the parent mails the code and then passes a new
 * `sentAt` value (`Date.now()`), which clears the boxes and restarts the
 * countdown. Used by every step of the data deletion flow that asks for a code.
 */
@Component({
  selector: 'app-otp-verify-box',
  templateUrl: './otp-verify-box.component.html',
  standalone: false,
})
export class OtpVerifyBoxComponent implements OnDestroy {
  constructor(public service: CommonService) {}

  /** Address the code was mailed to, shown above the boxes. */
  @Input() sentToEmail: string = '';
  /** Inline message shown under the boxes. */
  @Input() errorMessage: string = '';
  @Input() resendAfterInSeconds: number = 30;

  /** Any new value restarts the countdown - pass Date.now() after a send. */
  @Input() set sentAt(sentAt: number) {
    if (!sentAt || sentAt === this.lastSentAt) {
      return;
    }
    this.lastSentAt = sentAt;
    this.otpCode = '';
    this.otpInputRef?.setValue('');
    this.startResendTimer();
  }

  @Output() otpChange = new EventEmitter<string>();
  @Output() resendOtp = new EventEmitter<void>();

  @ViewChild('otpInput') otpInputRef: NgOtpInputComponent;

  readonly otpLength: number = OTP_LENGTH;
  readonly config = {
    allowNumbersOnly: true,
    length: this.otpLength,
    isPasswordInput: false,
    disableAutoFocus: false,
    placeholder: '',
    inputStyles: {
      color: 'black',
      background: 'transparent',
    },
  };

  otpCode: string = '';
  timeLeft: number = 0;
  private lastSentAt: number;
  private resendTimerInterval: any;

  ngOnDestroy(): void {
    this.clearResendTimer();
  }

  onOtpChange(otpCode: string) {
    this.otpCode = otpCode;
    this.otpChange.emit(otpCode);
  }

  onResendOtp() {
    if (this.timeLeft > 0) {
      return;
    }
    this.resendOtp.emit();
  }

  private startResendTimer() {
    this.clearResendTimer();
    this.timeLeft = this.resendAfterInSeconds;
    this.resendTimerInterval = setInterval(() => {
      this.timeLeft--;
      if (this.timeLeft <= 0) {
        this.clearResendTimer();
      }
    }, 1000);
  }

  private clearResendTimer() {
    if (this.resendTimerInterval) {
      clearInterval(this.resendTimerInterval);
      this.resendTimerInterval = null;
    }
  }
}
